import { Grid, Typography } from '@mui/material';
import { useEffect } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useAppDispatch } from '../../../../../../Redux/store';
import { CertificationArrayType } from '../../../../../../Schemas/ResumeSchemas';
import { setNextDisabled } from '../../../Slices/TalentProfileCreationSlice';
import { CertificationSection } from './CertificationSection';

interface CertificationsForm {
    CertificationName: string;
    YearObtained: string;
}

interface IProps {
    certificationsForm: UseFormReturn<CertificationArrayType>
}
export const Certifications = ({ certificationsForm }: IProps) => {
    /* ******************** Hooks ******************** */
    const dispatch = useAppDispatch();
    const { 
        control,
        formState: { isValid }
    } = certificationsForm
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */

    /* ******************** Effects ******************** */
    useEffect(() => {
        isValid ? dispatch(setNextDisabled(false)) : dispatch(setNextDisabled(true));
    }, [isValid])
    /* ******************** JSX ******************** */
    return (
        <Grid container gap={'20px'} display={"flex"} flexDirection={"column"}>
            <Typography variant='lora-title-large' color={'primary'} fontWeight={'bold'}>Add your certifications</Typography>
            <Grid item sx={{overflowY: "auto"}} maxHeight={"550px"} gap={'20px'} display={"flex"} flexDirection={"column"} paddingRight={4}>
                <CertificationSection control={control} />
            </Grid>
        </Grid>
    )
}